function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BF94"
    },
    d: "M3.452,480.181c-0.204-0.519-0.39-1.045-0.575-1.573H2.862 C3.049,479.138,3.248,479.661,3.452,480.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BF94"
    },
    d: "M256,411.826h-16.696l-33.391,28.939l-33.391-28.939H116.87l-34.504,31.165l-32.278-31.165 C22.424,411.826,0,434.251,0,461.913c0,5.859,1.026,11.472,2.876,16.696l280.95,24.487L256,411.826z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578C76"
    },
    d: "M511.613,77.857c0.255-1.8,0.387-3.639,0.387-5.51c0-16.656-10.456-30.862-25.159-36.433 c0.002-0.008-82.12-31.124-82.12-31.124C396.54,1.707,387.689,0,378.435,0c-14.345,0-27.73,4.082-39.081,11.13H256l-30.052,90.157 L511.613,77.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578C76"
    },
    d: "M361.739,231.513h-128L256,311.652h27.826l33.391-23.374l33.391,23.374h11.13 c27.662,0,50.087,22.424,50.087,50.087c0,27.662-22.424,50.087-50.087,50.087l-33.391,24.487l-33.391-24.487H256v85.704h105.739 c64.442,0,132.452-71.349,132.452-135.791S426.181,231.513,361.739,231.513z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BF94"
    },
    d: "M150.261,94.609L256,92.383V11.13H150.261C67.275,11.13,0,78.404,0,161.391 c0,82.986,67.275,150.261,150.261,150.261h11.13l33.391-25.6l33.391,25.6H256l0.184-86.122l-105.923,2.643 c-46.03,0-64.557-20.753-64.557-66.783S104.231,94.609,150.261,94.609z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84D993"
    },
    d: "M83.478,445.217c18.441,0,33.391-14.95,33.391-33.391H50.087 C50.087,430.267,65.037,445.217,83.478,445.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84D993"
    },
    d: "M205.913,445.217c18.441,0,33.391-14.95,33.391-33.391h-66.783 C172.522,430.267,187.472,445.217,205.913,445.217z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BF94"
    },
    d: "M328.348,445.217c18.441,0,33.391-14.95,33.391-33.391h-66.783 C294.957,430.267,309.907,445.217,328.348,445.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84D993"
    },
    d: "M194.783,278.261c-18.441,0-33.391,14.95-33.391,33.391h66.783 C228.174,293.211,213.223,278.261,194.783,278.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BF94"
    },
    d: "M317.217,278.261c-18.441,0-33.391,14.95-33.391,33.391h66.783 C350.609,293.211,335.658,278.261,317.217,278.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9F291"
    },
    d: "M2.862,478.609c0.187,0.53,0.386,1.052,0.591,1.573c0.052,0.135,0.105,0.268,0.159,0.402 c0.204,0.505,0.413,1.006,0.632,1.504c0.048,0.11,0.099,0.217,0.148,0.327c0.722,1.607,1.527,3.172,2.409,4.685 c0.048,0.082,0.095,0.165,0.142,0.248c0.268,0.454,0.545,0.903,0.828,1.347c0.092,0.145,0.185,0.29,0.278,0.434 c0.282,0.434,0.567,0.864,0.86,1.288c0.078,0.112,0.158,0.222,0.237,0.334c0.951,1.348,1.967,2.646,3.043,3.891 c0.137,0.158,0.273,0.317,0.411,0.474c0.307,0.346,0.62,0.688,0.937,1.026c0.168,0.179,0.338,0.356,0.509,0.534 c0.315,0.327,0.631,0.652,0.955,0.969c0.166,0.164,0.338,0.322,0.506,0.483c0.598,0.572,1.21,1.129,1.835,1.67 c0.204,0.176,0.405,0.356,0.611,0.529c0.308,0.259,0.623,0.508,0.937,0.759c0.253,0.201,0.505,0.402,0.761,0.599 c0.306,0.235,0.616,0.466,0.928,0.695c0.284,0.206,0.57,0.409,0.858,0.61c0.298,0.209,0.597,0.42,0.899,0.622 c0.419,0.279,0.845,0.549,1.273,0.816c0.374,0.234,0.751,0.46,1.131,0.683c0.387,0.228,0.776,0.454,1.17,0.672 c0.283,0.156,0.569,0.305,0.855,0.456c0.373,0.197,0.748,0.39,1.126,0.577c0.283,0.14,0.567,0.279,0.853,0.414 c0.425,0.201,0.855,0.393,1.287,0.582c0.24,0.106,0.477,0.214,0.72,0.316c0.656,0.275,1.318,0.536,1.987,0.784 c0.209,0.077,0.423,0.147,0.633,0.22c0.494,0.175,0.992,0.346,1.493,0.505c0.265,0.085,0.531,0.164,0.798,0.245 c0.472,0.141,0.946,0.276,1.424,0.404c0.257,0.07,0.514,0.139,0.774,0.205c0.583,0.147,1.171,0.28,1.762,0.406 c0.148,0.031,0.295,0.068,0.444,0.099c0.736,0.149,1.478,0.281,2.225,0.396c0.216,0.033,0.434,0.061,0.651,0.091 c0.549,0.079,1.1,0.15,1.654,0.21c0.262,0.028,0.524,0.055,0.787,0.078c0.542,0.051,1.086,0.091,1.634,0.125 c0.24,0.014,0.481,0.031,0.722,0.042c0.777,0.038,1.558,0.061,2.346,0.061H256l56.765-33.391H2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84D993"
    },
    d: "M379.548,77.913H186.991L256,111.304h122.435C378.435,102.4,379.548,94.609,379.548,77.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BF94"
    },
    d: "M378.435,37.101c-20.49,0-37.101,16.612-37.101,37.102c0,1.252,0.063,2.489,0.185,3.71 c1.862,18.748,17.678,33.391,36.916,33.391c0,0,81.732,0,100.174,0c18.441,0,33.391-14.95,33.391-33.391h-96.835 c0.835,0,0.372-3.71,0.372-3.71C415.537,53.713,398.926,37.101,378.435,37.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9F291"
    },
    d: "M150.261,77.913c-46.03,0-83.478,37.447-83.478,83.478s37.448,83.478,83.478,83.478H321.67 L256,211.478H150.261c-27.662,0-50.087-22.424-50.087-50.087s22.424-50.087,50.087-50.087H256V77.913H150.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84D993"
    },
    d: "M361.739,211.478H256v33.391h105.739c64.442,0,116.87,52.427,116.87,116.87 s-52.428,116.87-116.87,116.87H256V512h105.739C444.727,512,512,444.727,512,361.739C512,278.753,444.727,211.478,361.739,211.478z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnake);
export default __webpack_public_path__ + "static/media/snake.fb401c14d955dd5355e676a6fd9c2db9.svg";
export { ForwardRef as ReactComponent };